import Vue from 'vue';
import CraftUi from '@pixelandtonic/craftui';

Vue.use(CraftUi);
